<div class="m-3">
    <span *ngFor="let skillGroup of skills">
        <app-skills-group [skillGroup]="skillGroup"></app-skills-group>
    </span>
</div>
